import script from "./NewSalesListsView.vue?vue&type=script&setup=true&lang=js"
export * from "./NewSalesListsView.vue?vue&type=script&setup=true&lang=js"

import "./NewSalesListsView.vue?vue&type=style&index=0&id=41d8d86a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41d8d86a"]])

export default __exports__